"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegularStartDate = exports.DeliveryStartDate = exports.EndDate = exports.StartDate = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const roomCreateStore_1 = require("@/room/room_create/roomCreateStore");
const moment_1 = __importDefault(require("moment"));
const react_1 = require("@mobiscroll/react");
require("@mobiscroll/react/dist/css/mobiscroll.react.min.css");
const react_i18next_1 = require("react-i18next");
const detect_utils_1 = require("@/common/detect_utils");
const svgs_1 = require("@@/assets/svgs");
const styled_1 = __importDefault(require("@emotion/styled"));
const localeObj = {
    ko: react_1.localeKo,
    zh_hans: react_1.localeZh,
    en: react_1.localeEn,
    ja: react_1.localeJa,
};
const dateFormat = 'YYYY.MM.DD';
const timeFormat = 'HH:mm';
const addZeroSec = (date) => {
    if (typeof date === 'string') {
        const isoDate = date.slice(0, 16);
        return `${isoDate}:00`;
    }
};
const StartDate = ({ disabled }) => {
    const locale = localeObj[(0, detect_utils_1.currentLanguage)()];
    const startDate = (0, react_redux_1.useSelector)((state) => state.roomData.start_date);
    const isValid = (0, react_redux_1.useSelector)((state) => state.roomData.isValid);
    const roomStatusCd = (0, react_redux_1.useSelector)((state) => state.roomData.room_status_cd);
    const isTemp = Boolean(roomStatusCd == 'ROOM_STATUS_00');
    const minDate = isValid || (!isValid && isTemp) ? undefined : new Date();
    const endDate = (0, react_redux_1.useSelector)((state) => state.roomData.end_date);
    const maxDate = (0, moment_1.default)(endDate).subtract(1, 'm');
    const dispatch = (0, react_redux_1.useDispatch)();
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(PickerDiv, Object.assign({ className: disabled ? 'surface-bg' : 'surface-white' }, { children: [(0, jsx_runtime_1.jsx)(react_1.Datepicker, { disabled: disabled, theme: "black", controls: ['calendar', 'time'], min: minDate, defaultValue: startDate, max: maxDate, setText: t('확인'), cancelText: t('취소'), focusOnClose: false, inputTyping: false, dateFormat: dateFormat, timeFormat: timeFormat, timeWheels: 'HH:mm', locale: locale, returnFormat: "iso8601", onChange: e => dispatch((0, roomCreateStore_1.setStartDate)(addZeroSec(e.value))) }, `start_date_picker_${disabled}`), !disabled && (0, jsx_runtime_1.jsx)(svgs_1.ChevronDownSvg, {})] })));
};
exports.StartDate = StartDate;
const EndDate = ({ disabled }) => {
    const locale = localeObj[(0, detect_utils_1.currentLanguage)()];
    const startDate = (0, react_redux_1.useSelector)((state) => state.roomData.start_date);
    const minDate = (0, moment_1.default)(startDate).add(1, 'm');
    const endDate = (0, react_redux_1.useSelector)((state) => state.roomData.end_date);
    const secondStartDate = (0, react_redux_1.useSelector)((state) => state.roomData.second_start_date);
    const deliveryStartDate = (0, react_redux_1.useSelector)((state) => state.roomData.support_delivery_date);
    const secondDeadline = (0, react_redux_1.useSelector)((state) => state.roomData.second_deadline);
    const secondPaid = (0, react_redux_1.useSelector)((state) => state.roomData.second_paid);
    const isDemandSurvey = (0, react_redux_1.useSelector)((state) => state.isDemandSurvey);
    const maxDate = isDemandSurvey
        ? (0, moment_1.default)().add(1, 'y')
        : (0, moment_1.default)(secondDeadline && secondPaid
            ? secondStartDate
            : !!deliveryStartDate
                ? deliveryStartDate
                : (0, moment_1.default)().add(6, 'M')).subtract(1, 'm');
    const dispatch = (0, react_redux_1.useDispatch)();
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(PickerDiv, Object.assign({ className: disabled ? 'surface-bg' : 'surface-white' }, { children: [(0, jsx_runtime_1.jsx)(react_1.Datepicker, { disabled: disabled, theme: "black", themeVariant: "light", controls: ['calendar', 'time'], min: minDate, defaultValue: endDate, max: maxDate, setText: t('확인'), cancelText: t('취소'), focusOnClose: false, inputTyping: false, dateFormat: dateFormat, timeFormat: timeFormat, timeWheels: 'HH:mm', locale: locale, returnFormat: "iso8601", onChange: e => dispatch((0, roomCreateStore_1.setEndDate)(addZeroSec(e.value))) }, `end_date_picker_${disabled}`), !disabled && (0, jsx_runtime_1.jsx)(svgs_1.ChevronDownSvg, {})] })));
};
exports.EndDate = EndDate;
const DeliveryStartDate = () => {
    const locale = localeObj[(0, detect_utils_1.currentLanguage)()];
    const endDate = (0, react_redux_1.useSelector)((state) => state.roomData.end_date);
    const secondEndDate = (0, react_redux_1.useSelector)((state) => state.roomData.second_end_date);
    const deliveryStartDate = (0, react_redux_1.useSelector)((state) => state.roomData.support_delivery_date);
    const secondDeadline = (0, react_redux_1.useSelector)((state) => state.roomData.second_deadline);
    const secondPaid = (0, react_redux_1.useSelector)((state) => state.roomData.second_paid);
    const minDate = (0, moment_1.default)(secondDeadline && secondPaid ? secondEndDate : endDate).add(1, 'm');
    const maxDate = (0, moment_1.default)().add(1, 'y');
    const dispatch = (0, react_redux_1.useDispatch)();
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(PickerDiv, { children: [(0, jsx_runtime_1.jsx)(react_1.Datepicker, { theme: "black", themeVariant: "light", controls: ['calendar', 'time'], min: minDate, defaultValue: deliveryStartDate, max: maxDate, setText: t('확인'), cancelText: t('취소'), focusOnClose: false, inputTyping: false, dateFormat: dateFormat, timeFormat: timeFormat, timeWheels: 'HH:mm', locale: locale, returnFormat: "iso8601", onChange: e => dispatch((0, roomCreateStore_1.setDeliveryStartDate)(addZeroSec(e.value))), placeholder: t('배송 예정일을 선택해주세요') }), (0, jsx_runtime_1.jsx)(svgs_1.ChevronDownSvg, {})] }));
};
exports.DeliveryStartDate = DeliveryStartDate;
const RegularStartDate = () => {
    const locale = localeObj[(0, detect_utils_1.currentLanguage)()];
    const startDate = (0, react_redux_1.useSelector)((state) => state.roomData.start_date);
    const isValid = (0, react_redux_1.useSelector)((state) => state.roomData.isValid);
    const roomStatusCd = (0, react_redux_1.useSelector)((state) => state.roomData.room_status_cd);
    const isTemp = Boolean(roomStatusCd == 'ROOM_STATUS_00');
    const minDate = isValid || (!isValid && isTemp) ? undefined : new Date();
    const maxDate = (0, moment_1.default)().add(1, 'y');
    const dispatch = (0, react_redux_1.useDispatch)();
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(PickerDiv, { children: [(0, jsx_runtime_1.jsx)(react_1.Datepicker, { theme: "black", themeVariant: "light", controls: ['calendar', 'time'], min: minDate, defaultValue: startDate, max: maxDate, setText: t('확인'), cancelText: t('취소'), focusOnClose: false, inputTyping: false, dateFormat: dateFormat, timeFormat: timeFormat, timeWheels: 'HH:mm', locale: locale, returnFormat: "iso8601", onChange: e => dispatch((0, roomCreateStore_1.setStartDate)(addZeroSec(e.value))) }), (0, jsx_runtime_1.jsx)(svgs_1.ChevronDownSvg, {})] }));
};
exports.RegularStartDate = RegularStartDate;
const PickerDiv = styled_1.default.div `
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  border: 1px solid var(--gray-10);
  border-radius: 8px;
  cursor: pointer;
  .mbsc-ios.mbsc-textfield-wrapper-underline {
    width: 100%;
    height: 100%;
    margin: 0;
    background: none;
  }
  .mbsc-ios.mbsc-form-control-wrapper::before,
  .mbsc-ios.mbsc-form-control-wrapper::after {
    border-top: 0;
  }
  .mbsc-ios.mbsc-textfield-inner {
    height: 100%;
    opacity: 1;
  }
  .mbsc-ios.mbsc-textfield {
    height: inherit;
    padding: 0;
    padding-left: 14px;
    @media (max-width: 400px) {
      padding-left: 8px;
    }
    font-size: 15px;
    color: var(--gray-80);
    cursor: pointer;
  }
  .mbsc-ios.mbsc-textfield.mbsc-disabled {
    color: var(--gray-20);
    -webkit-text-fill-color: var(--gray-40) !important;
    opacity: 1;
  }
  svg {
    position: absolute;
    right: 10px;
    @media (max-width: 400px) {
      right: 4px;
    }
    width: 20px;
    height: 20px;
    pointer-events: none;
  }
`;
